<div [formGroup]="form">
    <div class="custom-file d-none">
      <input 
        #file
        type="file" 
        class="custom-file-input" 
        [accept]="accept" 
        (change)="onSelectFile($event)">
      <label class="custom-file-label" for="anexoContrato">Escolha um arquivo...</label>
    </div>
    <div class="col-12" >
      <button 
        class="btn btn-primary rounded-pill btn-sm" 
        (click)="file.click()"
        >Anexar {{documents.length ? 'outro' : null}} arquivo em {{accept.slice(1)}}
      </button>
      <div class="" *ngIf="documents.length > 0">
            <div  class="row" 
                [formArrayName]="name"  
                *ngFor="let item of documents.controls;
                        index as i" 
            >
                <a 
                    id="downloadFile"
                    title="Baixar o documento anexado" 
                    class="mx-2 btn rounded-pill btn-sm" 
                    (click)="downloadFromWeb(i)"        
                >  
                    <i class="fas fa-paperclip fa-lg"></i>
                    {{getOneFileName(item)}}
                </a>
                <button 
                    class="btn rounded-pill btn-outline-danger border-0 rounded-circle"
                    (click)="removeDocument(i)"
                    title="Remover documento"
                >
                    <i class="fas fa-times"></i>
                </button>
                <button 
                    class="btn rounded-pill btn-outline-primary border-0 rounded-circle"
                    (click)="downloadFromWeb(i)"
                    title="Baixar o documento anexado"
                >
                    <i class="fas fa-download"></i>
                </button>
    
          </div>
      </div>
      
    </div>

  </div>
